// @see my.liquidweb.com
import type { AppConfigI } from './example';

const prod: AppConfigI = {
	baseURL: 'https://api.liquidweb.com/',
	session: {
		length: 900,
		warningTime: 150,
	},
	hosts: {
		www: 'www.liquidweb.com',
		cart: 'cart.liquidweb.com',
		manage: 'manage.liquidweb.com',
		salesforce: 'liquidweb.lightning.force.com/lightning/r',
		customer_community: 'help.liquidweb.com/s',
		managed_apps: 'app.liquidweb.com',
		authorize_net: 'accept.authorize.net',
		gator: 'gator.liquidweb.com',
	},
	gaTrackerId: 'G-4H92SYZK1F',
	gtmContainerId: 'GTM-T9MXBTTB',
	cartStack: {
		siteId: 'k5FaX1dK',
		trackingScriptUrl:
			'https://api.cartstack.com/js/customer-tracking/cart.liquidweb.com_71f77bbc0c9db256f407bbc6821d6994.js',
	},
	guestAuth: {
		username: 'remote-signup',
		password: 's|gnm3up',
	},
	cart: {
		checkoutURL: 'https://www.liquidweb.com/cart/checkout',
		configURL: 'https://www.liquidweb.com/configuration',
		cookieDomain: 'liquidweb.com',
		payPalSystem: 'portal_lw',
		payPalSignUpSystem: 'portal_signup_lw',
	},
	chatConfig: {
		enabled: true,
		orgId: '00D30000000pmDy',
		deploymentId: 'Liquid_Web_Support_Portal_MIAW',
		communityURL:
			'https://liquidweb.my.site.com/ESWLiquidWebSupportPor1740147560083',
		scrt2URL: 'https://liquidweb.my.salesforce-scrt.com',
		messagingScriptURL:
			'https://liquidweb.my.site.com/ESWLiquidWebSupportPor1740147560083/assets/js/bootstrap.min.js',
		settings: {
			language: 'en_US',
			chatButtonPosition: '32px,32px',
		},
		storageDomain: 'liquidweb.com',
	},
	openId: {
		client_id: 'lw-portal',
		authority: 'https://login.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
	algolia: {
		applicationId: 'J360JFWYSQ',
		searchOnlyApiKey: '0b82cb616431ca0e42b6818bd8259bb8',
	},
	feedback: {
		boardToken: '3944a62d-8e1c-d786-85f7-dd2b55dbf6c3',
	},
	googleMapsApiKey: 'AIzaSyCp1q6YD7Sqz-XNwB8XV5VCetTr-JcQVMc',
	acceptJs: {
		src: 'https://js.authorize.net/v1/Accept.js',
		merchantKeys: {
			'65HksN97':
				'9E8G988CRTtEsMcLhnFdvg947ArCyBB93TH7Q7Ny4kvLx9ntxw58Lf7cmtcLCSNu',
			'8HH729nFtQ':
				'566WwmKxHh5UBhHvcHMgP96ZQ8XmjR3eCkW3Xg759QrfXAz2wUca3WPgzm9ugWwa',
			'8R89bPjL':
				'3pbSVBb422mQbFk7TAdB4p5tdEampd6XyAzeEP72BhxfWTHR873tPh8EDg8PQ9pz',
			hnzr87b:
				'4e32vp3u9EEsC3qSF9baCu6rJvE9uPVRytX2X53RHxUt8x8QkFAyJ34qsXLcz2Md',
			'3at84NWq':
				'7TgbupC8GTSNRj2f3mpKcvYvtx3yzfD65Nz9Z3FW3Rk5yzp56FSQpCEVHy57J5u8',
		},
		fallbackMerchant: {
			key: '4e32vp3u9EEsC3qSF9baCu6rJvE9uPVRytX2X53RHxUt8x8QkFAyJ34qsXLcz2Md',
			id: 'hnzr87b',
		},
	},
	theme: 'liquidweb',
	brand: 'liquidweb',
};

export default prod;
